'use client'

import { Stack, Typography, Box } from '@mui/material'
import dynamic from 'next/dynamic'
const VideoPlayer = dynamic(
  () =>
    import('@biolumina/ui/components/videoPlayer/videoPlayer').then(
      (m) => m.VideoPlayer
    ),
  {
    ssr: false,
    loading: () => (
      <div
        style={{
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto 40px',
          aspectRatio: '16/9',
        }}
      />
    ),
  }
)
import { HomepageHero } from '@biolumina/ui/components/homepageHero/HomepageHero'
import { Callout } from '@biolumina/ui/components/callout/callout'
import { Button } from '@biolumina/ui/components/button/button'
import { Link } from '@biolumina/ui/components/link/link'
import { Footnote } from '@biolumina/ui/components/footnote/footnote'
import { PageLayout } from '../pageLayout'

export default function Home() {
  return (
    <PageLayout hero={<HomepageHero />} curved className="dark">
      <Typography
        fontWeight={800}
        fontSize={{ xs: '1.8rem', md: '2.375rem' }}
        textAlign="center"
        lineHeight={1.383}
        color="primary.main"
        mb={3}
        component="h2"
      >
        IBTROZI
        {
          /*
          <Box
            component="sup"
            sx={{ display: { xs: 'inline', md: 'none' }, fontSize: '0.6em' }}
          >
            ™
          </Box>
          */
        }
        <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
          {' '}
          (taletrectinib)
        </Box>{' '}
        is a nonchemotherapy, targeted oral treatment designed specifically for
        adults with advanced ROS1+ NSCLC
      </Typography>

      <Typography variant="h3" sx={{ color: 'primary.main' }}>
        What is IBTROZI?
      </Typography>
      <Typography variant="body1">
        IBTROZI<sup>&reg;</sup> (taletrectinib) is a prescription medicine used to treat
        adults with non-small cell lung cancer (NSCLC) that has spread within
        your chest or to other parts of the body and is caused by an abnormal{' '}
        <em>ROS1</em> gene.
      </Typography>
      <Typography variant="body1" marginBottom="40px">
        It is not known if IBTROZI is safe and effective in children.
      </Typography>

      <Typography variant="h2" alignContent="center">
        Moving forward: an IBTROZI story
      </Typography>

      <Typography variant="h3" sx={{ color: 'primary.main' }}>
        IBTROZI is brought to you by Nuvation Bio Inc. 
      </Typography>

      <VideoPlayer
        sources={[
          {
            src: '/video/hls/patient-video.m3u8',
            type: 'application/x-mpegURL',
          },
          { src: '/video/IBTROZI_Patient_Video_Matt.mp4', type: 'video/mp4' },
        ]}
        poster="/video/IBTROZI_Patient_Video_Matt.webp"
        data-video-title="matts-story"
        sx={{
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto 40px',
          borderRadius: '8px',
        }}
      />

      <Footnote marginBottom="40px">
        NSCLC=non-small cell lung cancer; ROS1+=ROS proto-oncogene
        1&ndash;positive.
      </Footnote>

      <Stack
        pt={2}
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="center"
        spacing={{ xs: 2, md: 3 }}
        margin={0}
        mb={4}
      >
        <Callout
          className="tertiary"
          cta={
            <Link
              component={Button}
              className="flex"
              trackingId="results"
              sx={{
                outline: 'none',
                color: 'black',
                '&:hover': {
                  outline: 'none',
                  backgroundColor: '#062059',
                  color: 'white',
                  svg: { fill: 'white' },
                },
              }}
              href="/about-ibtrozi"
            >
              Explore study results
            </Link>
          }
        >
          <Typography>
            <strong>About IBTROZI</strong>
          </Typography>
        </Callout>

        

        <Callout
          className="secondary"
          cta={
            <Link
              component={Button}
              className="flex"
              trackingId="brochure"
              sx={{
                outline: 'none',
                color: 'black',
                '&:hover': {
                  outline: 'none',
                  backgroundColor: 'primary.main',
                  color: 'white',
                  svg: { fill: 'white' },
                },
              }}
              target="_blank"
              href="/pdf/IBTROZI-Patient-Brochure.pdf"
            >
              Download brochure
            </Link>
          }
        >
          <Typography>
            <strong>Getting started on IBTROZI</strong>
          </Typography>
        </Callout>

        <Callout
          className="primary"
          cta={
            <Button
              className="flex"
              trackingId="support-nuvation_connect"
              sx={{
                outline: 'none',
                color: 'black',
                '&:hover': {
                  outline: 'none',
                  backgroundColor: 'tertiary.main',
                  color: 'white',
                  svg: { fill: 'white' },
                },
              }}
              href="https://www.nuvationconnect.com"
              target="_blank"
            >
              Discover more
            </Button>
          }
        >
          <Typography color="common.white">
            <strong>
              Explore personalized support with NuvationConnect
              <sup>&trade;</sup>
            </strong>
          </Typography>
        </Callout>

      </Stack>
    </PageLayout>
  )
}
